import api from "./axiosInstance";
import { resolvePartnerImg } from "../utils/partnerImage";

export const getBlogImageUrl = (img) => resolvePartnerImg(img) || "";

export const createBlog = (blogData) => {
  return api.post(`/blogs/uploadblogs`, blogData);
};

export const getAllBlogs = () => {
  return api.get(`/blogs/loadallblogs`);
};

export const getBlogById = (id) => {
  return api.get(`/blogs/loadblogbyid/${id}`);
};

export const getBlogBySlug = (slug) => {
  return api.get(`/blogs/loadblogbyslug/${slug}`);
};

export const updateBlogStatus = (id, status) => {
  return api.put(`/blogs/update-status/${id}`, { status });
};

export const deleteBlog = (id) => {
  return api.put(`/blogs/deleteblog/${id}`);
};

export const updateBlog = (id, data) => {
  return api.put(`/blogs/updateblog/${id}`, data);
};
